import { render, staticRenderFns } from "./EditTotal.vue?vue&type=template&id=3c4c57a8&scoped=true&"
import script from "./EditTotal.vue?vue&type=script&lang=js&"
export * from "./EditTotal.vue?vue&type=script&lang=js&"
import style0 from "./EditTotal.vue?vue&type=style&index=0&id=3c4c57a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c57a8",
  null
  
)

export default component.exports